export default "__VITE_ASSET__CatDVzVT__"